module.exports = __webpack_public_path__ + "static/media/trofeus (1).273428f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (1).jpg
// module id = 365
// module chunks = 0